<button *ngIf="!navigateTo" class="button" [disabled]="disabled" [matTooltip]="tooltip" [matTooltipDisabled]="!tooltip" [ngStyle]="buttonStyles"
    [attr.aria-label]="(!label && accessibleLabel) ? accessibleLabel : null"
    (click)="btnClicked($event)">
    <span *ngIf="startIcon?.name && startIcon?.name !== 'custom'" class="icon material-symbols-rounded"
        [class.rotating]="startIcon?.rotating"
        [class.filled-symbol]="startIcon?.isFilled"
        [ngStyle]="startIconStyles">{{startIcon?.name}}</span>
        <ng-container *ngIf="startIcon?.name === 'custom' && startIcon.svgPath">
            <img [src]="startIcon.svgPath" [style.height.px]="16" [style.width.px]="16" alt=""/>
        </ng-container>
    <img *ngIf="image" [src]="image" alt="" />
    <span *ngIf="label" class="label" [ngStyle]="labelStyles">{{label}}</span>
    <span *ngIf="endIcon?.name" class="icon material-symbols-rounded" [class.rotating]="endIcon?.rotating" [class.filled-symbol]="endIcon?.isFilled" [ngStyle]="endIconStyles">{{endIcon?.name}}</span>
</button>
<a [href]="navigateTo" target="_blank" *ngIf="navigateTo" class="button" [matTooltip]="tooltip" [matTooltipDisabled]="!tooltip" [ngStyle]="buttonStyles"
    [attr.aria-label]="(!label && accessibleLabel) ? accessibleLabel : null"
    (click)="btnClicked($event)">
    <span *ngIf="startIcon?.name" class="icon material-symbols-rounded"
        [class.rotating]="startIcon?.rotating"
        [class.filled-symbol]="startIcon?.isFilled"
        [ngStyle]="startIconStyles">{{startIcon?.name}}</span>
    <img *ngIf="image" [src]="image" alt="" />
    <span *ngIf="label" class="label" [ngStyle]="labelStyles">{{label}}</span>
    <span *ngIf="endIcon?.name" class="icon material-symbols-rounded" [class.rotating]="endIcon?.rotating" [class.filled-symbol]="endIcon?.isFilled" [ngStyle]="endIconStyles">{{endIcon?.name}}</span>
</a>